import type { SavedSearch } from "@gjwtrack/domain";
import { useState } from "react";
import { client } from "../lib/client.ts";
import { Button, Checkbox, Dialog, DialogContent, DialogHeader, Input, InputSize, Panel } from "../ui/ring.ts";
import { uuid } from "@gjwtrack/client";

/** YouTrack's "Edit saved search": name, query, shared with everyone. */
export function SavedSearchDialog({ search, onClose }: { search: SavedSearch; onClose: () => void }) {
  const [name, setName] = useState(search.name);
  const [query, setQuery] = useState(search.query);
  const [shared, setShared] = useState(search.shared);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const save = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    try {
      await client.http.command("updateSavedSearch", { savedSearchId: search.id, name: name.trim(), query: query.trim(), shared }, uuid());
      await client.loadSavedSearches();
      onClose();
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  };
  return (
    <Dialog show label="Edit saved search" onCloseAttempt={onClose} showCloseButton trapFocus autoFocusFirst={false}>
      <DialogHeader>Edit saved search</DialogHeader>
      <DialogContent>
        <div className="flex w-[32rem] max-w-full flex-col gap-3">
          <Input size={InputSize.FULL} label="Name" autoFocus value={name} onChange={(e) => setName(e.target.value)} />
          <Input size={InputSize.FULL} label="Search query" inputClassName="font-mono" value={query} onChange={(e) => setQuery(e.target.value)} />
          <Checkbox label="Share with everyone" checked={shared} onChange={(e) => setShared(e.target.checked)} />
          {error && <div className="text-danger">{error}</div>}
        </div>
      </DialogContent>
      <Panel>
        <Button primary disabled={busy || !name.trim()} onClick={() => void save()}>
          Save
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </Panel>
    </Dialog>
  );
}
